import React from 'react'
import CTAButton from "../../../components/core/HomePage/Button";
import { FaArrowRight } from "react-icons/fa";
import Instructor from "../../../assets/Images/Teacher.webp";
import HighlightText from './HighlightText';
import { motion } from 'framer-motion';
import { scaleUp } from '../../Common/Scroll';
const InstructorSection = () => {
  return (
    <div>
        <div className="flex flex-col lg:flex-row gap-20 items-center">
          <motion.div
           variants={scaleUp}
           initial='hidden'
           whileInView={'show'}
           viewport={{ once: false, amount: 0.1 }}
           className="lg:w-[50%]">
            <img
              src={Instructor}
              alt=""
              className="shadow-yellow-50 shadow-[-20px_-20px_0_0]"
            />
          </motion.div>
          <div className="lg:w-[50%] flex gap-10 flex-col">
            <h1 className="lg:w-[50%] text-4xl font-semibold text-richblack-600 ">
              Become an
              <HighlightText text={"instructor"} />
            </h1>

            <p className="font-medium text-[16px] text-justify w-[90%] text-richblack-200">
              Instructors from around the world teach millions of students on
              Course Catalyst. We provide the tools and skills to teach what you
              love.
            </p>

            <div className="w-fit">
              <CTAButton active={true} linkto={"/signup"}>
                <div className="flex items-center gap-3">
                  Start Teaching Today
                  <FaArrowRight />
                </div>
              </CTAButton>
            </div>
          </div>
        </div>
    </div>
  )
}

export default InstructorSection
